import { useRecoilValue } from 'recoil'
import { UserTier } from 'src/common-services'

import { meetsTier } from 'src/atoms/user'
import { isLocationFree } from 'src/atoms/search'
import { isIframe } from 'src/atoms/matthews'

export const useTier = (tier?: UserTier) => {
  const _isIframe = useRecoilValue(isIframe)
  // Check for matthews iframe
  if (_isIframe) {
    return true
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const _isLocationFree = useRecoilValue(isLocationFree)
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const _meetsTier = useRecoilValue(meetsTier(tier))
  // first check if pid is in the list of free lids
  if (_isLocationFree) {
    return true
  }
  // if not, check if the user has access to this feature based on their tier
  return _meetsTier
}
